module.exports = __webpack_public_path__ + "img/zz.d37f2ff5.png";